import React from "react";
import { IconProps } from "../../assets/icons/types";
import { StyleType } from "../../types";

export type IconSize = "small" | "medium" | "large";

export type IconProp = { size: IconSize; color?: string };

export type IconWrapperProps = {
  Icon: ({ width, height, fill }: IconProps) => JSX.Element;
  styleType?: StyleType;
};

export const heightSizeMap: Record<IconSize, string> = {
  small: "16",
  medium: "24",
  large: "32",
};

export const widthSizeMap: Record<IconSize, string> = {
  small: "16",
  medium: "23",
  large: "31",
};

export const iconPropsMap: Record<StyleType, IconProp> = {
  default: { size: "large", color: "#000" },
  AHSRebrand: { size: "medium", color: "#1d1363" },
  HBW210: { size: "medium", color: "#141b4d" },
};

export const IconWrapper = ({
  Icon,
  styleType,
}: IconWrapperProps): JSX.Element => {
  return (
    <Icon
      height={heightSizeMap[iconPropsMap[styleType || "default"].size]}
      width={widthSizeMap[iconPropsMap[styleType || "default"].size]}
      fill={iconPropsMap[styleType || "default"].color}
    ></Icon>
  );
};
